module.exports = __webpack_public_path__ + "static/img/leiniao-benefit-video_free.802fde8e.png";